module.exports = __webpack_public_path__ + "img/screen1.d8b6a0b1.png";